import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "./Sidebar";
import SplitPane from "react-split-pane";
import ManageAccount from "./Profile/ManageAccount";
import pixaLogo from "../Img/pixaLogo.png";
import AdminHeader from "./AdminHeader";
import CategoryMetaManagement from "./PasswordManager/CategoryMetaManagement/CategoryMetaManagement";
import BankMetaManagement from "./PasswordManager/BankMetaManagement/BankMetaManagement";
import DatabaseMetaManagement from "./PasswordManager/DatabaseMetaManagement/DatabaseMetaManagement";
import CardMetaManagement from "./PasswordManager/CardMetaManagement/CardMetaManagement";
import FileMetaManagement from "./PasswordManager/FileMetaManagement/FileMetaManagement";
import StorageMetaManagement from "./PasswordManager/StorageMetaManagement/StorageMetaManagement";
import OtherImageLibraryMetaManagement from "./OtherImageLibraryManagement/OtherImageLibraryManagement";
import FormManagement from "./WorkBridge/FormManagement/FormManagement";
import FormMetaManagement from "./PasswordManager/FormMetaManagement/FormMetaManagement";
import DiscoveryCategoryManagement from "./DiscoveryControls/CategoryManagement/DiscoveryCategoryManagement";
import DiscoverySubCategoryManagement from "./DiscoveryControls/SubCategoryManagement/DiscoverySubCategoryManagement";
import BlogCategoryManagement from "./BlogManagement/CategoryManagement/BlogCategoryManagement";
import BlogSubCategoryManagement from "./BlogManagement/SubCategoryManagement/BlogSubCategoryManagement";
import BlogManagement from "./BlogManagement/BlogManagemnt/BlogManagement";
import SitePilotIntegration from "./SitePilotManagement/SitePilotIntegration/SitePilotIntegration";
import SitePilotAddons from "./SitePilotManagement/SitePilotAddons/SitePilotAddons";
import SitePilotClientManagement from "./SitePilotManagement/ClientManagement/SitePilotClientManagement";
import VoultClientManagement from "./PasswordManager/ClientManagement/VoultClientManagement";
import MailTemplate from "./MailTemplateManagement/MailTemplate";

const Dashboard = ({ getCurrectLoginUser, currentUserData }) => {
  const [activeItem, setActiveItem] = useState("");
  return (
    <>
      <Container fluid>
        <Row>
          <Col md={12} className="p-0">
            <SplitPane
              split="vertical"
              minSize={"20%"}
              className="position-relative"
              style={{ height: "100vh" }}
            >
              <div className="bg-light">
                <div className="p-2">
                  <img src={pixaLogo} alt="" style={{height: 38, objectFit:"contain"}} />
                </div>
                <Sidebar
                  activeItem={activeItem}
                  setActiveItem={setActiveItem}
                />
              </div>
              <div>
                <AdminHeader
                  getCurrectLoginUser={getCurrectLoginUser}
                  currentUserData={currentUserData}
                  activeItem={activeItem}
                  setActiveItem={setActiveItem}
                />
                {activeItem === "manageAccount" &&
                  <ManageAccount
                    currentUserData={currentUserData}
                    getCurrectLoginUser={getCurrectLoginUser}
                  />
                }
                {activeItem === "category" &&
                  <CategoryMetaManagement />
                }
                {activeItem === "discoveryCategory" &&
                  <DiscoveryCategoryManagement />
                }
                {activeItem === "discoverySubCategory" &&
                  <DiscoverySubCategoryManagement />
                }
                {activeItem === "blogCategory" &&
                  <BlogCategoryManagement />
                }
                {activeItem === "blogSubCategory" &&
                  <BlogSubCategoryManagement />
                }
                {activeItem === "blogPost" &&
                  <BlogManagement />
                }
                {activeItem === "formMeta" &&
                  <FormMetaManagement />
                }
                {activeItem === "fileMeta" &&
                  <FileMetaManagement />
                }
                {activeItem === "bankMeta" &&
                  <BankMetaManagement />
                }
                {activeItem === "cardMeta" &&
                  <CardMetaManagement />
                }
                {activeItem === "vaultClients" &&
                  <VoultClientManagement />
                }
                {activeItem === "sitePilotClients" &&
                  <SitePilotClientManagement />
                }
                {activeItem === "mailTemplates" &&
                  <MailTemplate />
                }
                {activeItem === "forms" &&
                  <FormManagement />
                }
                {activeItem === "databaseMeta" &&
                  <DatabaseMetaManagement />
                }
                {activeItem === "storageMeta" &&
                  <StorageMetaManagement />
                }
                {activeItem === "otherLibrary" &&
                  <OtherImageLibraryMetaManagement />
                }
                {activeItem === "sitePilotIntegrations" &&
                  <SitePilotIntegration />
                }
                {activeItem === "sitePilotAddons" &&
                  <SitePilotAddons />
                }
              </div>
            </SplitPane>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Dashboard;
